import React from 'react';
import { IconUIComponentProps, useIconStyle } from './Icon';

export default function ({
  color,
  size,
  style,
  className,
  noFill,
}: IconUIComponentProps) {
  const styles = useIconStyle({ noFill });
  return (
    <svg
      className={[styles.icon, className].join(' ').trim()}
      color={color}
      fontSize={size}
      style={style}
      viewBox="0 0 16 12"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M7.33334 3.33887V1C7.33334 0.448563 6.88478 0 6.33334 0C6.08528 0 5.84572 0.0950626 5.66016 0.267594L5.22981 0.665719C3.81381 1.97591 1.44337 4.16862 0.230469 5.38509C0.0820312 5.53484 0 5.75294 0 6C0 6.24706 0.0820312 6.46516 0.230469 6.61525C1.44337 7.83141 3.81381 10.0241 5.22981 11.3343L5.66016 11.7324C5.84572 11.905 6.08528 12 6.33334 12C6.88478 12 7.33334 11.5515 7.33334 11V8.66897C12.1335 8.73634 15.3333 10.2503 15.3333 11.6667C15.3333 11.8509 15.4824 12 15.6667 12C15.8509 12 16 11.8509 16 11.6667C16 7.17481 12.1426 3.50162 7.33334 3.33887ZM7 8C6.81575 8 6.66666 8.14909 6.66666 8.33334V11C6.66666 11.1839 6.51691 11.3333 6.33331 11.3333C6.23175 11.3333 6.15753 11.2845 6.11325 11.2435L5.68291 10.8451C4.27019 9.53809 1.90625 7.35125 0.703125 6.14484C0.684906 6.12663 0.666656 6.07453 0.666656 6C0.666656 5.92547 0.684875 5.87338 0.703125 5.85547C1.90625 4.64875 4.27019 2.46191 5.68294 1.15494L6.11328 0.7565C6.15756 0.715469 6.23178 0.666656 6.33334 0.666656C6.51694 0.666656 6.66669 0.816062 6.66669 1V3.66666C6.66669 3.85091 6.81578 4 7.00003 4C11.0078 4 14.364 6.61653 15.1563 10.0902C13.7337 8.84406 10.6537 8 7 8Z" />
    </svg>
  );
}
